export const apiConfig = {
  resourceScopes: [import.meta.env.VITE_AZURE_CLIENT_ID + '/.default'],
};
